import { network } from 'services/network';

import { QueryFnResponse, QueryParams } from 'api/queries/getSummaryKpi.query';

export const getSummaryKpi = (params: Omit<QueryParams, 'runQsra'>): Promise<QueryFnResponse> => {
    return network.post('api/bo/getSummaryKpi', params).then((response) => {
        return response.data;
    });
};
